import { render, staticRenderFns } from "./TeamChat.vue?vue&type=template&id=057ae285&"
import script from "./TeamChat.vue?vue&type=script&lang=js&"
export * from "./TeamChat.vue?vue&type=script&lang=js&"
import style0 from "./TeamChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports